import React from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { VeCoLogo } from './VeCoLogo';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white/80 backdrop-blur-md">
      <div className="container mx-auto px-4">
        <div className="flex h-20 items-center justify-between">
          {/* Logo */}
          <div className="flex items-center cursor-pointer group" onClick={() => scrollToSection('home')}>
            <img 
              src="/veco-logo.jpeg" 
              alt="VeCo Shop Logo" 
              className="h-16 w-auto object-contain group-hover:scale-105 transition-transform duration-200"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-1">
            <Button
              variant="ghost"
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-teal-600 hover:bg-teal-50"
            >
              Home
            </Button>
            <Button
              variant="ghost"
              onClick={() => scrollToSection('activities')}
              className="text-gray-700 hover:text-teal-600 hover:bg-teal-50"
            >
              Attività
            </Button>
            <Button
              variant="ghost"
              onClick={() => scrollToSection('come-funziona')}
              className="text-gray-700 hover:text-teal-600 hover:bg-teal-50"
            >
              Come Funziona
            </Button>
            <Button
              variant="ghost"
              onClick={() => scrollToSection('regolamento')}
              className="text-gray-700 hover:text-teal-600 hover:bg-teal-50"
            >
              Regolamento
            </Button>
            <Button
              variant="ghost"
              onClick={() => scrollToSection('veco-point')}
              className="text-gray-700 hover:text-teal-600 hover:bg-teal-50"
            >
              VeCo Point
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </Button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden py-4 border-t animate-in slide-in-from-top">
            <div className="flex flex-col space-y-2">
              <Button
                variant="ghost"
                onClick={() => scrollToSection('home')}
                className="justify-start text-gray-700 hover:text-teal-600 hover:bg-teal-50"
              >
                Home
              </Button>
              <Button
                variant="ghost"
                onClick={() => scrollToSection('activities')}
                className="justify-start text-gray-700 hover:text-teal-600 hover:bg-teal-50"
              >
                Attività
              </Button>
              <Button
                variant="ghost"
                onClick={() => scrollToSection('come-funziona')}
                className="justify-start text-gray-700 hover:text-teal-600 hover:bg-teal-50"
              >
                Come Funziona
              </Button>
              <Button
                variant="ghost"
                onClick={() => scrollToSection('regolamento')}
                className="justify-start text-gray-700 hover:text-teal-600 hover:bg-teal-50"
              >
                Regolamento
              </Button>
              <Button
                variant="ghost"
                onClick={() => scrollToSection('veco-point')}
                className="justify-start text-gray-700 hover:text-teal-600 hover:bg-teal-50"
              >
                VeCo Point
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};